import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Grid,
  Typography,
  TextField,
  Button,
  Divider,
  Box,
} from '@mui/material';
import { fetchPost } from '../../api/common';
import { Profile } from '@par/shared/types/player';
import './styles.css';
import { GoogleSignIn } from './GoogleSignIn';

type PropTypes = {
  setProfile: (profile: Profile) => void;
};

export const Login = ({ setProfile }: PropTypes) => {
  const emailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: any) => {
    //Prevent page reload
    event.preventDefault();
    if (!emailRef.current || !passwordRef.current) {
      return setError('Fill in all fields');
    }

    try {
      setError('');
      setLoading(true);
      const res = await fetchPost('/authenticate/login', {
        email: emailRef.current.value,
        password: passwordRef.current.value,
      });
      if (res) {
        setProfile(res);
        navigate('/');
      }
    } catch (e: unknown) {
      if (e instanceof Response) {
        const errRes = await e.json();
        if (errRes.message) {
          setError(errRes.message);
        }
      } else {
        setError('Failed to login');
      }
    }

    setLoading(false);
  };

  const renderErrorMessage = () => (
    <Typography color="error.main">{error}</Typography>
  );

  return (
    <>
      <Grid item>{renderErrorMessage()}</Grid>
      <Grid item>
        <Typography component="h1" variant="h5" sx={{ marginBottom: '24px' }}>
          Sign in
        </Typography>
      </Grid>

      <Grid item>
        <form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                type="email"
                placeholder="Email"
                fullWidth
                variant="outlined"
                name="username"
                inputRef={emailRef}
                required
                autoFocus
              />
            </Grid>
            <Grid item>
              <TextField
                type="password"
                placeholder="Password"
                fullWidth
                variant="outlined"
                name="pass"
                inputRef={passwordRef}
                required
              />
            </Grid>
            <Grid item>
              {!loading ? (
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className="button-block"
                >
                  Sign in
                </Button>
              ) : null}
            </Grid>
            {process.env.REACT_APP_GOOGLE_CLIENT_ID ? (
              <Grid item>
                <GoogleSignIn setProfile={setProfile} />
              </Grid>
            ) : null}

            <Grid item>
              {!loading ? (
                <Button
                  variant="outlined"
                  component={Link}
                  color="primary"
                  to="/forgot-password"
                  className="button-block"
                >
                  Forgot Password
                </Button>
              ) : null}
            </Grid>
          </Grid>
          <Divider className="login-divider"> or </Divider>
          <Grid item>
            <Button
              href="#text-buttons"
              component={Link}
              to="/signup"
              className="button-block"
            >
              Join Now
            </Button>
          </Grid>
        </form>
      </Grid>
    </>
  );
};
